import React from 'react';
import Hero from '@/components/Hero';
import SEO from '@/components/SEO';
import { Button } from '@/components/ui/button';
import { Check, Database, LogIn } from 'lucide-react';

const Index = () => {
  const features = [
    {
      title: "Access to 5,000+ trusted local pros",
      description: "Find, quote, book, and pay for repairs, maintenance, and\nhome improvement projects."
    },
    {
      title: "Trusted Pros list",
      description: "Easily save and find your favourite contractors\nand service providers."
    },
    {
      title: "Free for homeowners",
      description: "Set-up and manage two properties for free."
    },
    {
      title: "Keep Organized with our Home Binder",
      description: "Keep your property details, documents, photos, and\nrecords organized and ready when you need them."
    }
  ];

  return (
    <>
      <SEO
        title="Metronome is now House Beat | Home Management Platform" 
        description="We've evolved Metronome into House Beat, with a new look, clearer focus, and meaningful upgrades designed to help you stay organized, avoid surprises, and take better care of your home."
        imageUrl="/SocialShareImage.png"
        keywords={['house beat', 'metronome', 'home management', 'home maintenance', 'homeownership', 'property management']}
      />
      <Hero />
      
      {/* Nothing Lost Section */}
      <section className="py-16 md:py-24 bg-gray-50">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl">
          <h2 className="text-3xl sm:text-4xl font-bold text-foreground mb-6">
            Nothing lost<span style={{ color: '#62e28d' }}>.</span> Everything ready<span style={{ color: '#62e28d' }}>.</span>
          </h2>
          
          <div className="space-y-4">
            <div className="flex items-start gap-3">
              <Database className="w-6 h-6 text-blue-500 flex-shrink-0 mt-0.5" aria-hidden="true" />
              <span className="text-lg text-gray-600 font-bold">
                Your home and property information from Metronome has been<br />
                securely carried over.
              </span>
            </div>
            <div className="flex items-start gap-3">
              <LogIn className="w-6 h-6 text-[#62e28d] flex-shrink-0 mt-0.5" aria-hidden="true" />
              <span className="text-lg text-gray-600 font-bold">
                Log in at housebeat.com using the same email and password you used for Metronome, and don't miss a beat.
              </span>
            </div>
          </div>
        </div>
      </section>
      
      {/* What's New Section */}
      <section className="py-16 md:py-24 bg-white">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl">
          <h2 className="text-3xl sm:text-4xl font-bold text-foreground mb-6">
            What's new with House Beat?
          </h2>
          
          <p className="text-lg text-gray-600 mb-8 font-bold">
            Everything you used in Metronome, plus more ways to manage, protect, and improve your home:
          </p>
          
          <ul className="space-y-6">
            {features.map((feature, index) => (
              <li key={index} className="flex flex-col gap-1">
                <div className="flex items-center gap-3">
                  <Check className="w-6 h-6 text-[#62e28d] flex-shrink-0" aria-hidden="true" />
                  <span className="text-foreground text-lg font-bold">{feature.title}</span>
                </div>
                <span className="text-foreground text-lg ml-9">
                  {feature.description.split('\n').map((line, i) => (
                    <React.Fragment key={i}>
                      {line}
                      {i < feature.description.split('\n').length - 1 && <br />}
                    </React.Fragment>
                  ))}
                </span>
              </li>
            ))}
          </ul>
        </div>
      </section>
      
      {/* CTA Section */}
      <section className="py-16 md:py-24 bg-gray-50">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <a 
            href="https://app.housebeat.com" 
            target="_blank" 
            rel="noopener noreferrer"
            aria-label="Go to House Beat application"
          >
            <Button 
              size="lg"
              className="min-h-[56px] px-12 py-4 text-lg font-bold"
            >
              Take me to House Beat
            </Button>
          </a>
        </div>
      </section>
    </>
  );
};

export default Index;
